import { Numbers, metricType } from './typeConstants';

export const metricValueFormat = (metricValue: any, metricTypeName: string): string => {
    if (metricValue === null || metricValue === undefined) return '--';
    
    const numericValue = parseFloat(metricValue);
    
    if (isNaN(numericValue)) return '--';
    
    const formattedValue = numericValue.toFixed(Numbers.TWO);
    return metricTypeName?.toLowerCase() === metricType.PERCENTAGE
        ? `${(numericValue * Numbers.HUNDRED).toFixed(Numbers.TWO)}%`
        : formattedValue;
};

export const metricValueFormatWithoutUnit = (metricValue: any, metricTypeName: string): string => {
    if (metricValue === null) return '--'; // Handle null case first

    const formattedValue = metricValue?.toFixed(Numbers.TWO);

    return metricTypeName?.toLowerCase() === metricType.PERCENTAGE
        ? (metricValue * Numbers.HUNDRED).toFixed(Numbers.TWO)
        : formattedValue;
};

export const CaluculateMetricValue = (metricValue: any, metricTypeName: string): number => {
    if (metricValue === null) return 0; // Handle null case first

    return metricTypeName?.toLowerCase() === metricType.PERCENTAGE
        ? Number((metricValue * Numbers.HUNDRED).toFixed(Numbers.TWO))
        : metricValue;
};
